import { useCallback, useMemo, useRef } from 'react'
import cx from 'classnames'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import { ImageType } from '../types'
import { BlockSectionTitle, BlockWrapper, BynderPicture, Container, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


TestimonialImages.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      image: ImageType,
      name: PropTypes.string,
      subheading: PropTypes.string,
      text: PropTypes.string,
    })),
  }),
}

export default function TestimonialImages({
  data = {
    items: [],
  },
}) {
  const secondOption = useRef()
  const onMouseEnter = useCallback(event => {
    secondOption.current.classList.remove(classNames.hover)
    event.target.classList.add(classNames.hover)
  }, [])
  const onMouseLeave = useCallback(event => {
    event.target.classList.remove(classNames.hover)
    secondOption.current.classList.add(classNames.hover)
  }, [])

  const items = useMemo(() => get(data, 'items', []).map(({ image, name, subheading, text }, index) => (
    <div
      key={index}
      ref={index === 1 ? secondOption : null}
      className={cx(classNames.item, index === 1 && classNames.hover)}
      style={{ zIndex: get(data, 'items', []).length - index }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <BynderPicture
        image={image}
        className={classNames.image}
        desktopImage={{
          maxWidth: 400,
          maxHeight: 400,
          sizes: '400px',
        }}
        mobileImage={{
          maxWidth: 400,
          maxHeight: 400,
          sizes: '400px',
        }}
      />
      <div className={classNames.content}>
        <Typography variant="h3" color="white">{name}</Typography>
        <Typography variant="content" color="light-gray">{subheading}</Typography>
        <div className={classNames.separator} />
        <Typography variant="content" className={classNames.quote}>{text}</Typography>
      </div>
    </div>
  )), [data?.items])

  return (
    <BlockWrapper spacing="content">
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <div className={classNames.circles}>{items}</div>
      </Container>
    </BlockWrapper>
  )
}
